// src/i18n.ts
import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

i18n.use(initReactI18next).init({
  resources: {
    heb: {
      translation: {
        // Login
        'login.form.title': 'התחברות',
        'login.form.email': 'אימייל',
        'login.form.password': 'סיסמה',

        // Common
        'common.loading': 'טוען…',
        'common.srNo': 'מס׳',
        'common.actions': 'פעולות',
        'common.edit': 'ערוך',
        'common.delete': 'מחק',
        'common.add': 'הוסף',
        'common.update': 'עדכן',
        'common.select': 'בחר',
        'common.email': 'אימייל',
        'common.password': 'סיסמה',
        'common.yes': 'כן',
        'common.no': 'לא',
        'common.logout': 'התנתקות',
        'common.days': 'יום',
        'common.weeks': 'שבוע',
        'common.months': 'חודש',
        'common.years': 'שנה',
        'common.settings': 'הגדרות',

        // Dashboard
        'dashboard.title': 'דשבורד',

        // Operations
        'operations.title': 'תפעול',

        // Checklist
        'checklist.title': 'צ’קליסטים',

        // Forms
        'forms.title': 'טפסים',
        'forms.pageTitle': 'טפסים',
        'forms.table.formName': 'שם טופס',
        'forms.table.creator': 'שם יוצר',
        'forms.table.phone': 'טלפון',
        'forms.table.responses': '# תגובות',
        'forms.table.creatorRole': 'תפקיד יוצר הטופס',
        'forms.table.status': 'סטאטוס',
        'forms.table.statusPublished': 'מפורסם',
        'forms.table.statusDraft': 'טיוטה',
        'forms.table.statusArchived': 'בארכיון',
        'forms.table.organization': 'בית עסק',
        'forms.table.createdAt': 'תאריך יצירה',
        'forms.table.updatedAt': 'עדכון אחרון',
        'forms.table.assignedTo': 'משוייך לקבוצה/מחלקה',
        'forms.actions.add': 'הוספה',
        'forms.actions.edit': 'עריכה',
        'forms.actions.copy': 'העתק',
        'forms.actions.archive': 'ארכיון',
        'forms.search.placeholder': 'חיפוש טופס',
        'forms.count': 'טפסים',
        'forms.menu.export': 'יצוא רשימה לאקסל',
        'forms.menu.print': 'הדפסת רשימת טפסים',
        'forms.menu.showArchived': 'הצגת ארכיון (מוסיף טפסים לא פעילים לטבלה)',
        'forms.archiveConfirm.title': 'שימו לב',
        'forms.archiveConfirm.message': 'הטופס יעבור לארכיון, האם להמשיך?',

        // Form Dialog
        'forms.dialog.formTitle': 'כותרת הטופס',
        'forms.dialog.formTitlePlaceholder': 'כותרת הטופס',
        'forms.dialog.description': 'תיאור',
        'forms.dialog.descriptionPlaceholder': 'תיאור',
        'forms.dialog.saveDraft': 'שמירה כטיוטה',
        'forms.dialog.publish': 'פרסם טופס',
        'forms.dialog.questionTitle': 'כותרת שאלה',
        'forms.dialog.mandatory': 'שאלת חובה',
        'forms.dialog.addQuestion': 'הוסף שאלה',
        'forms.dialog.add': 'הוסף',
        'forms.dialog.or': 'או',
        'forms.dialog.option': 'אפשרות',
        'forms.dialog.other': 'אחר',
        'forms.dialog.shortAnswerPlaceholder': 'טקסט של תשובה קצרה',

        // File upload question
        'forms.dialog.fileUpload.allowTypes': 'אפשור העלאת סוגי קבצים',
        'forms.dialog.fileUpload.allowedTypesRequired':
          'יש לבחור לפחות סוג קובץ אחד',
        'forms.dialog.fileUpload.maxFileSize': 'גודל קובץ מקסימלי',
        'forms.dialog.fileUpload.megaBytes': '{{count}} MB',
        'forms.dialog.fileUpload.type.word': 'מסמך Word',
        'forms.dialog.fileUpload.type.pdf': 'קובץ PDF',
        'forms.dialog.fileUpload.type.ppt': 'מצגת PPT',
        'forms.dialog.fileUpload.type.photo': 'תמונה',
        'forms.dialog.fileUpload.type.video': 'וידאו',
        'forms.dialog.fileUpload.type.audio': 'קובץ Audio',

        // Form Dialog Tabs
        'forms.dialog.tabs.questions': 'שאלות',
        'forms.dialog.tabs.settings': 'הגדרות',
        'forms.dialog.tabs.responses': 'תגובות',

        // Form Dialog Tooltips
        'forms.dialog.tooltip.qr.line1': 'יצירת QR-Code',
        'forms.dialog.tooltip.qr.line2': 'הדפסת QR-Code',
        'forms.dialog.tooltip.qr.line3': 'הצמדת QR-Code לטופס',
        'forms.dialog.tooltip.qr.notPublished':
          'יש לפרסם את הטופס כדי ש QR-Code יפעל',
        'forms.dialog.tooltip.share.line1': 'שיתוף טופס עם משתמשים',
        'forms.dialog.tooltip.share.line2': 'יש לפרסם את הטופס כדי שהלינק יפעל',
        'forms.dialog.tooltip.copy.line1': 'העתקת לינק לטופס',
        'forms.dialog.tooltip.copy.line2': 'יש לפרסם את הטופס כדי שהלינק יפעל',

        // Question Types
        'forms.dialog.questionType.shortAnswer': 'תשובה קצרה',
        'forms.dialog.questionType.multipleChoice': 'בחירה יחידה',
        'forms.dialog.questionType.checkbox': 'צ’קבוקס',
        'forms.dialog.questionType.linearScale': 'סקאלה לינארית (1-10)',
        'forms.dialog.questionType.rating': 'דירוג',
        'forms.dialog.questionType.date': 'תאריך',
        'forms.dialog.questionType.time': 'זמן',

        // Linear Scale
        'forms.dialog.linearScale.from': 'מ-',
        'forms.dialog.linearScale.to': 'עד-',
        'forms.dialog.linearScale.fromLabel': 'כותרת (לא חובה)',
        'forms.dialog.linearScale.toLabel': 'כותרת (לא חובה)',

        // Range
        'forms.dialog.range.type.numeric': 'ערך מספרי',
        'forms.dialog.range.type.textual': 'ערך טקסטואלי',
        'forms.dialog.range.type.temperature': 'טמפרטורה',
        'forms.dialog.range.form.between': 'בין לבין',
        'forms.dialog.range.form.range': 'טווח',
        'forms.dialog.range.form.fromTo': 'מינימום ומקסימום',
        'forms.dialog.range.from': 'מ-',
        'forms.dialog.range.to': 'ל',
        'forms.dialog.range.textual.from.low': 'נמוך',
        'forms.dialog.range.textual.from.short': 'קצר',
        'forms.dialog.range.textual.from.cold': 'קר',
        'forms.dialog.range.textual.to.high': 'גבוה',
        'forms.dialog.range.textual.to.long': 'ארוך',
        'forms.dialog.range.textual.to.hot': 'חם',
        'forms.dialog.range.allowImageUpload': 'אפשר למשיב להעלות תמונה',

        // Rating
        'forms.dialog.rating.limit': 'מגבלה',
        'forms.dialog.rating.icon': 'אייקון',
        'forms.dialog.rating.star': 'כוכב',
        'forms.dialog.rating.heart': 'לב',
        'forms.dialog.rating.thumbs': 'אגודל',

        // Date/Time
        'forms.dialog.dateTime.selectType': 'תזמון',
        'forms.dialog.dateTime.single': 'דיפולט בחירת יום',
        'forms.dialog.time.single': 'בחירת שעה',
        'forms.dialog.date.range': 'טווח ימים',
        'forms.dialog.time.range': 'טווח',
        'forms.dialog.dateTime.date': 'תאריך',
        'forms.dialog.dateTime.time': 'זמן',
        'forms.dialog.dateTime.datePlaceholder': 'שנה, חודש, יום',
        'forms.dialog.dateTime.from': 'מ-',
        'forms.dialog.dateTime.to': 'עד-',

        // Settings Tab
        'forms.dialog.settings.title': 'הגדרות',
        'forms.dialog.settings.general': 'כללי',
        'forms.dialog.settings.allRequired': 'הגדרת את כל השאלות של שאלות חובה',
        'forms.dialog.settings.countRespondents': 'ספור את מספר המשיבים',
        'forms.dialog.settings.anonymous': 'טופס אנונימי',
        'forms.dialog.settings.forCustomer': 'טופס ללקוחות',
        'forms.dialog.settings.recipientsTitle': 'הוספת נמענים',
        'forms.dialog.settings.organization': 'ארגון/ים',
        'forms.dialog.settings.departments': 'מחלקה/ות',
        'forms.dialog.settings.allDepartments': 'כל המחלקות',
        'forms.dialog.settings.recipients': 'שייוך אישי',
        'forms.dialog.settings.singleUse': 'חד פעמי',
        'forms.dialog.settings.scheduled': 'מתוזמן',
        'forms.dialog.settings.timing': 'תזמון',
        'forms.dialog.settings.timingDescription': 'הוספת תזמון לטופס',
        'forms.dialog.settings.timingType': 'לפי תאריך ושעה',
        'forms.dialog.settings.confirmationTitle': 'תגובה להעלאת הטופס',
        'forms.dialog.settings.confirmationPlaceholder': 'תשובתך התקבלה, תודה!',

        // Responses Tab
        'forms.dialog.responses.empty': 'אין תגובות עדיין',
        'forms.dialog.responses.title': 'תגובות',
        'forms.dialog.responses.responders': 'משיבים',
        'forms.dialog.responses.questions': 'שאלות',
        'forms.dialog.responses.print': 'הדפסה',
        'forms.dialog.responses.share': 'שיתוף',
        'forms.dialog.responses.tabs.byQuestion': 'לפי שאלה',
        'forms.dialog.responses.tabs.byResponder': 'לפי משיב',

        // Share Dialog
        'forms.dialog.share.formCreation': 'יצירת טופס',
        'forms.dialog.share.respondents': 'משיבים',
        'forms.dialog.share.respondentsDisplay': 'תצוגת משיבים',
        'forms.dialog.share.anyoneWithLink': 'כל מי שמקבל את הלינק',
        'forms.dialog.share.restricted': 'מוגבל',
        'forms.dialog.share.sendFormTo': 'שליחת טופס באפליקציה אל',
        'forms.dialog.share.associateToOrg': 'שייוך לארגון/סניף',
        'forms.dialog.share.cancel': 'ביטול',
        'forms.dialog.share.save': 'שמירה',

        // Public Form
        'forms.public.mandatoryLegend': 'שאלת חובה',
        'forms.public.next': 'הבא',
        'forms.public.prev': 'הקודם',
        'forms.public.submit': 'שלח טופס',
        'forms.public.clearForm': 'ניקוי טופס',
        'forms.public.clearConfirmTitle': 'ניקוי טופס',
        'forms.public.clearConfirmMessage':
          'האם אתה בטוח שברצונך לנקות את כל התשובות? לא ניתן לשחזר לאחר מכן.',
        'forms.public.notFound': 'הטופס לא נמצא',
        'forms.public.loading': 'טוען טופס...',
        'forms.public.clearField': 'נקה שדה טקסט',
        'forms.public.clearSelection': 'נקה בחירה',
        'forms.public.shortAnswerPlaceholder': 'כתבו כאן',
        'forms.public.dropdownPlaceholder': 'בחרו אפשרות',
        'forms.public.mandatoryError': 'שאלה זו היא שאלת חובה',
        'forms.public.incompleteTimeError': 'יש למלא גם שעות וגם דקות',
        'forms.public.dateRangeError':
          'תאריך ההתחלה חייב להיות לפני תאריך הסיום',
        'forms.public.timeRangeError': 'שעת ההתחלה חייבת להיות לפני שעת הסיום',
        'forms.public.rangeOrderError': 'ערך ה"מ" חייב להיות קטן מערך ה"עד"',
        'forms.public.rangeOutOfBoundsError': 'הערך חורג מהטווח המותר לשאלה זו',
        'forms.public.fileUpload.errors.invalidType':
          'סוג הקובץ אינו מותר לשאלה זו',
        'forms.public.fileUpload.errors.tooLarge':
          'גודל כל קובץ לא יעלה על {{max}} מ"ב',
        'forms.public.fileUpload.errors.tooMany': 'ניתן לצרף עד {{max}} קבצים',
        'forms.public.fileUpload.errors.maxReached': 'הגעת למספר הקבצים המרבי',
        'forms.public.fileUpload.errors.uploadFailed':
          'העלאת הקבצים נכשלה. נסו שוב.',
        'forms.public.submitted.description':
          'תודה שמילאת את הטופס. התשובות שלך נשמרו בהצלחה.',

        // Tasks
        'tasks.title': 'משימות',

        // Malfunctions
        'malfunctions.title': 'תקלות',

        // Working
        'working.title': 'עובדים',

        // Equipment & Instruments
        'equipmentAndInstruments.title': 'ציוד ומכשירים',

        // Suppliers
        'suppliers.title': 'ספקים',

        // Organizations
        'organizations.title': 'ניהול הארגון',

        // Tutorials
        'tutorials.title': 'הדרכות',

        // Reports
        'reports.title': 'דוחות',

        // Users
        'users.title': 'משתמשים',

        // Regulations
        'regulations.title': 'רגולציה',
      },
    },
    en: {
      translation: {
        // Login
        'login.form.title': 'Login',
        'login.form.email': 'Email',
        'login.form.password': 'Password',

        // Common
        'common.loading': 'Loading...',
        'common.srNo': `Sr.`,
        'common.actions': 'Actions',
        'common.edit': 'Edit',
        'common.delete': 'Delete',
        'common.add': 'Add',
        'common.update': 'Update',
        'common.select': 'Select',
        'common.email': 'Email',
        'common.password': 'Password',
        'common.yes': 'Yes',
        'common.no': 'No',
        'common.logout': 'Logout',
        'common.days': 'Days',
        'common.weeks': 'Weeks',
        'common.months': 'Months',
        'common.years': 'Years',
        'common.settings': 'Settings',

        // Dashboard
        'dashboard.title': 'Dashboard',

        // Operations
        'operations.title': 'Operations',

        // Checklist
        'checklist.title': 'Checklist',

        // Forms
        'forms.title': 'Forms',
        'forms.pageTitle': 'Forms',
        'forms.table.formName': 'Form Name',
        'forms.table.creator': 'Creator',
        'forms.table.phone': 'Phone',
        'forms.table.responses': '#Responses',
        'forms.table.creatorRole': 'Creator Role',
        'forms.table.status': 'Status',
        'forms.table.statusPublished': 'Published',
        'forms.table.statusDraft': 'Draft',
        'forms.table.statusArchived': 'Archived',
        'forms.table.organization': 'Organization',
        'forms.table.createdAt': 'Creation Date',
        'forms.table.updatedAt': 'Last Update',
        'forms.table.assignedTo': 'Assigned To',
        'forms.actions.add': 'Add',
        'forms.actions.edit': 'Edit',
        'forms.actions.copy': 'Copy',
        'forms.actions.archive': 'Archive',
        'forms.search.placeholder': 'Search form',
        'forms.count': 'forms',
        'forms.menu.export': 'Export list to Excel',
        'forms.menu.print': 'Print forms list',
        'forms.menu.showArchived':
          'Show archive (adds inactive forms to table)',
        'forms.archiveConfirm.title': 'Attention',
        'forms.archiveConfirm.message': 'The form will be archived, continue?',

        // Form Dialog
        'forms.dialog.formTitle': 'Form Title',
        'forms.dialog.formTitlePlaceholder': '*Form Title',
        'forms.dialog.description': 'Description',
        'forms.dialog.descriptionPlaceholder': 'Add description',
        'forms.dialog.saveDraft': 'Save as Draft',
        'forms.dialog.publish': 'Publish Form',
        'forms.dialog.questionTitle': 'Question Title',
        'forms.dialog.mandatory': 'Required Question',
        'forms.dialog.addQuestion': 'Add Question',
        'forms.dialog.add': 'add',
        'forms.dialog.or': 'or',
        'forms.dialog.option': 'option',
        'forms.dialog.other': 'other',
        'forms.dialog.shortAnswerPlaceholder': 'short answer text',

        // File upload question
        'forms.dialog.fileUpload.allowTypes': 'Allowed file types',
        'forms.dialog.fileUpload.allowedTypesRequired':
          'Select at least one file type',
        'forms.dialog.fileUpload.maxFileSize': 'Max file size',
        'forms.dialog.fileUpload.megaBytes': '{{count}} MB',
        'forms.dialog.fileUpload.type.word': 'Word document',
        'forms.dialog.fileUpload.type.pdf': 'PDF file',
        'forms.dialog.fileUpload.type.ppt': 'PPT presentation',
        'forms.dialog.fileUpload.type.photo': 'Photo',
        'forms.dialog.fileUpload.type.video': 'Video',
        'forms.dialog.fileUpload.type.audio': 'Audio',

        // Form Dialog Tabs
        'forms.dialog.tabs.questions': 'Questions',
        'forms.dialog.tabs.settings': 'Settings',
        'forms.dialog.tabs.responses': 'Responses',

        // Form Dialog Tooltips
        'forms.dialog.tooltip.qr.line1': 'Create QR-Code',
        'forms.dialog.tooltip.qr.line2': 'Print QR-Code',
        'forms.dialog.tooltip.qr.line3': 'Attach QR-Code to form',
        'forms.dialog.tooltip.qr.notPublished':
          'The form must be published for the QR-Code to work.',
        'forms.dialog.tooltip.share.line1': 'Share form with users',
        'forms.dialog.tooltip.share.line2': 'Publish form for link to work',
        'forms.dialog.tooltip.copy.line1': 'Copy form link',
        'forms.dialog.tooltip.copy.line2': 'Publish form for link to work',

        // Question Types
        'forms.dialog.questionType.multipleChoice': 'Multiple Choice',
        'forms.dialog.questionType.checkbox': 'Checkbox',
        'forms.dialog.questionType.shortAnswer': 'Short Answer',
        'forms.dialog.questionType.linearScale': 'Linear Scale',
        'forms.dialog.questionType.rating': 'Rating',
        'forms.dialog.questionType.date': 'Date',
        'forms.dialog.questionType.time': 'Time',

        // Linear Scale
        'forms.dialog.linearScale.from': 'From',
        'forms.dialog.linearScale.to': 'To',
        'forms.dialog.linearScale.fromLabel': 'Title (optional)',
        'forms.dialog.linearScale.toLabel': 'Title (optional)',

        // Range
        'forms.dialog.range.type.numeric': 'Numeric',
        'forms.dialog.range.type.textual': 'Textual',
        'forms.dialog.range.type.temperature': 'Temperature',
        'forms.dialog.range.form.between': 'Between',
        'forms.dialog.range.form.range': 'Range',
        'forms.dialog.range.form.fromTo': 'Min and Max',
        'forms.dialog.range.from': 'From',
        'forms.dialog.range.to': 'To',
        'forms.dialog.range.textual.from.low': 'Low',
        'forms.dialog.range.textual.from.short': 'Short',
        'forms.dialog.range.textual.from.cold': 'Cold',
        'forms.dialog.range.textual.to.high': 'High',
        'forms.dialog.range.textual.to.long': 'Long',
        'forms.dialog.range.textual.to.hot': 'Hot',
        'forms.dialog.range.allowImageUpload':
          'Allow respondent to upload an image',

        // Rating
        'forms.dialog.rating.limit': 'Limit',
        'forms.dialog.rating.icon': 'Icon',
        'forms.dialog.rating.star': 'Star',
        'forms.dialog.rating.heart': 'Heart',
        'forms.dialog.rating.thumbs': 'Thumbs',

        // Date/Time
        'forms.dialog.dateTime.selectType': 'Schedule',
        'forms.dialog.dateTime.single': 'Default Schedule',
        'forms.dialog.time.single': 'Choose a time',
        'forms.dialog.dateTime.range': 'Range',
        'forms.dialog.dateTime.date': 'Date',
        'forms.dialog.dateTime.time': 'Time',
        'forms.dialog.dateTime.datePlaceholder': 'Year, month, day',
        'forms.dialog.dateTime.from': 'From',
        'forms.dialog.dateTime.to': 'To',

        // Settings Tab
        'forms.dialog.settings.title': 'Settings',
        'forms.dialog.settings.general': 'General',
        'forms.dialog.settings.allRequired': 'Set all questions as required',
        'forms.dialog.settings.countRespondents': 'Count number of respondents',
        'forms.dialog.settings.anonymous': 'Anonymous form',
        'forms.dialog.settings.forCustomer': 'Form for customer',
        'forms.dialog.settings.recipientsTitle': 'Adding recipients',
        'forms.dialog.settings.recipients': 'Recipients',
        'forms.dialog.settings.organization': 'Organization(s)',
        'forms.dialog.settings.departments': 'Department(s)',
        'forms.dialog.settings.allDepartments': 'All Departments',
        'forms.dialog.settings.singleUse': 'Single use',
        'forms.dialog.settings.scheduled': 'Scheduled',
        'forms.dialog.settings.timing': 'Timing',
        'forms.dialog.settings.timingDescription': 'Add a schedule to a form',
        'forms.dialog.settings.timingType': 'By date and time',
        'forms.dialog.settings.confirmationTitle': 'Form submission response',
        'forms.dialog.settings.confirmationPlaceholder':
          'Your response was recorded, thank you!',

        // Responses Tab
        'forms.dialog.responses.empty': 'No responses yet',
        'forms.dialog.responses.title': 'Responses',
        'forms.dialog.responses.responders': 'Responders',
        'forms.dialog.responses.questions': 'Questions',
        'forms.dialog.responses.print': 'Print',
        'forms.dialog.responses.share': 'Share',
        'forms.dialog.responses.tabs.byQuestion': 'By Question',
        'forms.dialog.responses.tabs.byResponder': 'By Responder',

        // Share Dialog
        'forms.dialog.share.formCreation': 'Form creation',
        'forms.dialog.share.respondents': 'Respondents',
        'forms.dialog.share.respondentsDisplay': 'Respondents display',
        'forms.dialog.share.anyoneWithLink': 'Anyone with the link',
        'forms.dialog.share.restricted': 'Restricted',
        'forms.dialog.share.sendFormTo': 'Send form in app to',
        'forms.dialog.share.associateToOrg': 'Associate to organization/branch',
        'forms.dialog.share.cancel': 'Cancel',
        'forms.dialog.share.save': 'Save',

        // Public Form
        'forms.public.mandatoryLegend': 'Mandatory Question',
        'forms.public.next': 'Next',
        'forms.public.prev': 'Prev',
        'forms.public.submit': 'Submit',
        'forms.public.clearForm': 'Clean Form',
        'forms.public.clearConfirmTitle': 'Clean Form',
        'forms.public.clearConfirmMessage':
          'Are you sure you want to clear all answers? This cannot be undone.',
        'forms.public.notFound': 'Form not found',
        'forms.public.loading': 'Loading form...',
        'forms.public.clearField': 'Clear text field',
        'forms.public.clearSelection': 'Clear selection',
        'forms.public.shortAnswerPlaceholder': 'Write here',
        'forms.public.dropdownPlaceholder': 'Select an option',
        'forms.public.mandatoryError': 'This question is mandatory',
        'forms.public.incompleteTimeError':
          'Please fill in both hours and minutes',
        'forms.public.dateRangeError': 'Start date must be before end date',
        'forms.public.timeRangeError': 'Start time must be before end time',
        'forms.public.rangeOrderError':
          'The "from" value must be less than the "to" value',
        'forms.public.rangeOutOfBoundsError':
          'The value is outside the allowed range for this question',
        'forms.public.fileUpload.errors.invalidType':
          'This file type is not allowed for this question',
        'forms.public.fileUpload.errors.tooLarge':
          'Each file must be at most {{max}} MB',
        'forms.public.fileUpload.errors.tooMany':
          'You can attach at most {{max}} files',
        'forms.public.fileUpload.errors.maxReached':
          'You have reached the maximum number of files',
        'forms.public.fileUpload.errors.uploadFailed':
          'File upload failed. Please try again.',
        'forms.public.submitted.description':
          'Thank you for filling out the form. Your answers have been saved successfully.',

        // Tasks
        'tasks.title': 'Tasks',

        // Malfunctions
        'malfunctions.title': 'Malfunctions',

        // Working
        'working.title': 'Working',

        // Equipment & Instruments
        'equipmentAndInstruments.title': 'Equipments',

        // Suppliers
        'suppliers.title': 'Suppliers',

        // Organizations
        'organizations.title': 'Organizations',

        // Tutorials
        'tutorials.title': 'Tutorials',

        // Reports
        'reports.title': 'Reports',

        // Users
        'users.title': 'Users',

        // Regulations
        'regulations.title': 'Regulations',
      },
    },
  },
  lng: 'heb',
  fallbackLng: 'heb',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
